import { createFileRoute } from "@tanstack/react-router"
import { DrawRunner } from "@/features/live-events-admin/draws/DrawRunner"

export const Route = createFileRoute("/live-events/$eventId/draws")({
	component: DrawsPage,
})

function DrawsPage() {
	const { eventId } = Route.useParams()
	return <DrawRunner eventId={eventId} />
}
